import { origin } from '@porotutu/react/api'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({ baseURL: `${origin()}/api/auth/crm` })

export const { signIn, signUp, signOut } = authClient

export const leave = () => signOut()
